/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetPasswordModel
 */
export interface SetPasswordModel {
    /**
     * 
     * @type {number}
     * @memberof SetPasswordModel
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SetPasswordModel
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof SetPasswordModel
     */
    code: string;
}

export function SetPasswordModelFromJSON(json: any): SetPasswordModel {
    return SetPasswordModelFromJSONTyped(json, false);
}

export function SetPasswordModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetPasswordModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'password': json['password'],
        'code': json['code'],
    };
}

export function SetPasswordModelToJSON(value?: SetPasswordModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'password': value.password,
        'code': value.code,
    };
}

